module.exports = __webpack_public_path__ + "img/头部bg.2574b505.png";